/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum ClusterPageTabs {
  Overview,
  Plan,
  Advice,
  Parameters,
  ACL,
  Replicas,
  Backups,
  Datasets,
  Members,
  Application,
}

export const tabToRouteBinding = {
  [ClusterPageTabs.Application]: '',
  [ClusterPageTabs.Overview]: 'overview',
  [ClusterPageTabs.Plan]: 'plan',
  [ClusterPageTabs.Advice]: 'advice',
  [ClusterPageTabs.Parameters]: 'parameters',
  [ClusterPageTabs.ACL]: 'acl',
  [ClusterPageTabs.Replicas]: 'replicas',
  [ClusterPageTabs.Backups]: 'backups',
  [ClusterPageTabs.Datasets]: 'datasets',
  [ClusterPageTabs.Members]: 'members',
};
